var exports = {
  "kL": "GroupDMAvatar.module__container___cFR0eH",
  "kg": "GroupDMAvatar.module__statusDot___cFR0eH",
  "O0": "GroupDMAvatar.module__iconImageContainer___cFR0eH",
  "c4": "GroupDMAvatar.module__defaultIconContainer___cFR0eH",
  "DE": "GroupDMAvatar.module__defaultIcon___cFR0eH",
  "EQ": "GroupDMAvatar.module__multiAvatarContainer___cFR0eH",
};

module.exports = exports;
